module.exports = __webpack_public_path__ + "img/index_map_place02.d890b857.png";